<template>
	<v-dialog v-model="visible" fullscreen hide-overlay transition="dialog-bottom-transition">
		<v-card>
			<v-toolbar dark color="primary">
				<v-toolbar-title>
					Emitir e-Boleta
				</v-toolbar-title>
				<v-spacer></v-spacer>
				<v-toolbar-items>
					<v-btn icon @click="cerrar" :disabled="!puedeCerrar">
						<v-icon>close</v-icon>
					</v-btn>
				</v-toolbar-items>
			</v-toolbar>
			<v-card-text>
				<!-- <v-container> -->
					<!-- Previo a emitir -->
					<v-container v-show="porEmitir">
						<v-row dense>
							<v-col cols="12" class="title text-center text-h4" style="overflow-x:auto;">
								<span style="white-space: nowrap;">
									<!-- span es necesario para mostrar barra desplazamiento horizontal 
										si monto no se puede mostrar completamente
									-->
									{{ FORMATTERS.MONEY(monto) }}
								</span>
							</v-col>
						</v-row>
						<v-form	ref="formularioEmision" v-model="formularioEmisionValido" @submit.prevent>
							<v-row dense>
								<v-col cols="12">
									<v-select v-model="sucursal" :items="sucursales" label="Elija sucursal" ref="selectorSucursal"
										 solo flat hide-details="auto" item-value="codigo" return-object :rules="[validarSucursal]"
										 outlined :disabled="sucursales.length<=1">
										<template v-slot:item="{ item }">
											<!-- Ítemes en listado -->
											{{ item.nombre }}
										</template>
										<template v-slot:selection="{ item }">
											<!-- Ítem actualmente seleccionado -->
											{{ item.nombre }}
										</template>
									</v-select>
								</v-col>
								<v-col cols="12">
									<v-select v-model="tipoDte" :items="tiposDte" label="Elija tipo boleta" solo flat 
										hide-details="auto" item-text="nombre" item-value="codigo" return-object
										 :rules="[validarTipoDte]" outlined :disabled="tiposDte.length<=1">
									</v-select>
								</v-col>
								<v-col cols="12">
									<SelectorMetodoPago
										v-model="metodoPago"
										:rules="[validacionMontoMetodoPago]"
										:hint="mensajeMedioPago"
										:hide-details="!!mensajeMedioPago?false:'auto'"
										:persistent-hint="!!mensajeMedioPago"
										ref="metodoPagoSelector"
										@aplicar-config="aplicarConfig"
									/>
								</v-col>
							</v-row>
						</v-form>
						<v-row dense>
							<v-col cols="12" class="d-flex justify-start">
								<v-switch 
									:disabled="formConfig.bloquearSelectorReceptor"
									inset v-model="conReceptor" 
									hide-details class="my-3 ml-1" label="Receptor"
								>
								</v-switch>
							</v-col>
						</v-row>
						<v-row dense>
							<v-expand-transition>
								<v-col cols="12" v-show="conReceptor">
									<v-form ref="formularioReceptor" v-model="formularioReceptorValido">
										<v-row dense>
											<v-col cols="12" sm="4">
												<v-form @submit.prevent ref="formularioBusquedaReceptor" @submit.prevent>
													<v-text-field v-model="busquedaRutDvReceptor" label="RUT con DV receptor" solo flat hide-details="auto"
														:rules="[validarBusquedaRutDvReceptor]" @blur="cargarDatosReceptor" :loading="cargandoDatosReceptor" validate-on-blur
														:disabled="cargandoDatosReceptor || emitiendo" prepend-inner-icon="search" clearable ref="busquedaRutDvReceptor"
														outlined
														:error-messages="erroresRutReceptor"
													>
													</v-text-field>
												</v-form>
												<!-- Mantener esto oculto, es para facilitar reseteo de datos receptor -->
												<v-text-field v-model="rutDvReceptor" v-show="false" />
											</v-col>
											<v-col cols="12" sm="8">
												<v-text-field v-model="nombreReceptor" label="Nombre receptor" solo flat hide-details="auto"
													:disabled="cargandoDatosReceptor" prepend-inner-icon="perm_identity"
													 :rules="[validarNombreReceptor]" outlined>
												</v-text-field>
											</v-col>
											<v-col cols="12" sm="12">
												<v-text-field v-model="direccionReceptor" label="Dirección receptor" 
													solo flat hide-details="auto"
													:disabled="cargandoDatosReceptor" prepend-inner-icon="place" outlined
												>
												</v-text-field>
											</v-col>
											<v-col cols="12" sm="12">
												<v-text-field v-model="mailReceptor" label="E-mail receptor" solo flat hide-details="auto" :rules="[validarMailReceptor]" clearable
													prepend-inner-icon="mail" outlined
													@input="validarCampos"
												>
													<!-- TODO por implementar -->
												</v-text-field>
											</v-col>
											<v-col cols="12" sm="12">
												<v-text-field 
													v-model="fonoReceptor"
													label="Teléfono receptor"
													solo flat hide-details="auto"
													:rules="[validarTelefonoReceptor]"
													clearable
													prepend-inner-icon="smartphone" outlined
													@input="validarCampos"
												/>
											</v-col>
										</v-row>
									</v-form>
								</v-col>
							</v-expand-transition>
						</v-row>
						<v-row dense>
							<v-col cols="12" class="d-flex justify-start">
								<v-switch 
									inset v-model="conDetalle" hide-details 
									class="my-3 ml-1" label="Detalle" 
									:disabled="formConfig.bloquearSelectorDetalle || disabledConDetalle">
								</v-switch>
							</v-col>
						</v-row>
						<v-row dense>
							<v-expand-transition>
								<v-col cols="12" v-show="conDetalle">
									<v-form ref="formularioDetalle" v-model="formularioDetalleValido" @submit.prevent>
										<v-row dense>
											<v-col cols="12">
												<v-text-field v-model="nombreDetalle" label="Detalle" solo flat hide-details="auto" 
													:rules="[validarNombreDetalle]" outlined :counter="detalleMaxLength"
													@input="validarCampos"	
												>
												</v-text-field>
											</v-col>
										</v-row>
									</v-form>
								</v-col>
							</v-expand-transition>
						</v-row>
						<v-row dense>
							<v-col cols="12">
								<v-text-field v-model="vendedor" label="Vendedor" solo flat hide-details="auto" disabled outlined>
									<template v-slot:prepend-inner>
										Vendedor:
									</template>
								</v-text-field>
							</v-col>
						</v-row>
						<v-row dense>
							<v-col cols="12">
								<v-btn depressed x-large block color="success" @click="iniciarEmision" class="text-subtitle-1" 
									:disabled="!puedeEmitir" :loading="emitiendo">
									<!-- el loading fue a petición de rarmijo 2021-feb -->
									Emitir
								</v-btn>
							</v-col>
						</v-row>
					</v-container>
					<!-- Durante emisión -->
					<v-container v-show="emitiendo">
						<div class="text-center my-2">
							<v-progress-circular :size="150" :width="15" indeterminate color="warning"/>
						</div>
						<div class="text-center text-h6 my-6">
							{{ mensajeEstadoEmisionBoleta }}
						</div>
					</v-container>
					<!-- Emisión terminada -->
					<v-container v-show="emitido">
						<v-row>
							<v-col cols="12">
								<v-expand-transition>
									<v-progress-linear color="warning" buffer-value="0" :value="pdfProgresoCarga" stream v-show="!pdfCargado"/>
								</v-expand-transition>
								<v-sheet class="d-flex justify-center pa-2" v-if="emitido">
									<!-- NO quitar v-if, por bug en tamaño canvas vue-pdf -->
									<vue-pdf :src="urlPdf" style="max-height:1000px;border: solid 1px #ccc; display:inline-block;" @error="visorPdfError" 
										@loaded="visorpdfCargado" @progress="visorPdfProgreso" v-show="pdfCargado"/>
								</v-sheet>
							</v-col>
						</v-row>
						<v-row>
							<v-col cols="12">
								<v-btn color="success" depressed large block @click="imprimir" :disabled="b64Pdf===undefined">
									<v-icon left>
										print
									</v-icon>
									Imprimir
								</v-btn>
							</v-col>
							<v-col cols="12">
								<v-btn color="success" depressed large block :href="urlPdf" :disabled="urlPdf===undefined">
									<v-icon left>
										get_app
									</v-icon>
									Descargar
								</v-btn>
							</v-col>
							<v-col v-if="puedeCompartir" cols="12">
								<v-btn color="success" depressed large block @click="compartir">
									<v-icon left>
										share
									</v-icon>
									Compartir
								</v-btn>
							</v-col>
							<v-col cols="12">
								<div class="text-body-1 text-center">Escanea el código para ver tu boleta.</div>
								<QRCodigo class="ma-auto d-flex" :contenido="urlPdf"/>
							</v-col>
							<v-col cols="12">
								<v-form ref="formularioEnviarMail" v-model="formularioEnviarMailValido" @submit.prevent>
									<v-row dense>
										<v-col cols="12">
											<v-text-field v-model="mail" label="E-mail" solo flat hide-details="auto" prepend-inner-icon="mail" outlined 
												:rules="[validarMail]" clearable small>
												<template v-slot:append-outer>
													<v-btn color="warning" :loading="compartirData.loading" depressed block @click="enviarBoletaEmail" :disabled="!formularioEnviarMailValido">
														<v-icon left>
															send
														</v-icon>
													</v-btn>
												</template>
											</v-text-field>
										</v-col>
									</v-row>
								</v-form>
							</v-col>
							<v-col cols="12">
								<v-form ref="formularioEnviarWhatsapp" v-model="formularioEnviarWhatsappValido" @submit.prevent>
									<v-row dense>
										<v-col cols="12">
											<v-text-field v-model="telefono" label="Número de Contacto" solo flat hide-details="auto" prepend-inner-icon="phone_android" outlined 
												:rules="[validarTelefono]" clearable small placeholder="+569XXXXX">
												<template v-slot:append-outer>
													<v-btn color="warning" depressed block :href="urlWhatsapp" :disabled="!formularioEnviarWhatsappValido" target="_blank">
														<v-icon left>
															send
														</v-icon>
													</v-btn>
												</template>
											</v-text-field>
										</v-col>
									</v-row>
								</v-form>
							</v-col>
						</v-row>
					</v-container>
				<!-- </v-container> -->
			</v-card-text>
			<v-card-actions>
				<v-container class="d-flex justify-end">
					<!-- Botones inferiores -->
					<v-btn color="warning" depressed @click="cerrar" :disabled="!puedeCerrar">
						{{ emitido ? 'Cerrar' : 'Volver' }}
					</v-btn>
				</v-container>
			</v-card-actions>
		</v-card>
		<!-- Snackbar para notificaciones -->
		<v-snackbar v-model="notificacion.visible" bottom :color="notificacion.color" :timeout="15000">
			{{ notificacion.mensaje }}
			<v-btn dark text @click="notificacion.visible = false">
				Cerrar
			</v-btn>
		</v-snackbar>
	</v-dialog>
</template>

<script>
import vuePdf from 'vue-pdf';
import * as Boletas from '@/library/IntegracionApiBoletas/Boletas';
import * as ApiBoletasObjects from '@/library/IntegracionApiBoletas/Objects';
import * as AsyncExecUtils from '@/library/utils/async-exec';
import * as NavigatorShareUtils from '@/library/utils/nav-share';
import * as config from '@/config';
import * as InfoContribuyente from '@/library/utils/info-contribuyente';
import * as urlencode from 'urlencode';
import * as windowUtils from '@/library/utils/window';
import * as base64Utils from '@/library/utils/base64';
import printJS from 'print-js';
import { compartirBoletaEmail } from '@/library/utils/compartirBoleta';
import SelectorMetodoPago from '@/components/SelectorMetodoPago.vue'

import QRCodigo from '@/components/QRCodigo.vue'

import {apiPingSistema} from '@/library/api/config';

// Manejadores de ejecución asíncrona
let receptorDataExitoExecutionManager = AsyncExecUtils.AsyncExecutionManager();
let receptorDataErrorExecutionManager = AsyncExecUtils.AsyncExecutionManager();

// Constantes
const TIPOS_DTE = [
	{ 'nombre': 'Boleta afecta', 'codigo': Boletas.TIPOS_DTE.BOLETA_AFECTA_ELECTRONICA },
	{ 'nombre': 'Boleta exenta', 'codigo': Boletas.TIPOS_DTE.BOLETA_EXENTA_ELECTRONICA },
];
const CON_RECEPTOR_INICIAL = false;
const CON_DETALLE_INICIAL = false;
const NOMBRE_DETALLE_DEFECTO = 'Monto Total';
const MENSAJE_ESTADO_EMISION_INICIAL = '';
const POR_EMITIR = 0;
const EMITIENDO = 1;
const EMITIDO = 2;
const DETALLE_MAX_LENGTH = 80;

// RUTs
const SOFT_RUT_DV_REGEX = /^(\d+)-{0,1}([\d|k|K])$/;

// Formateador números
let FORMATTERS = config.FORMATTERS;

// Para diálogo imprimir
const ANDROID = windowUtils.windowHasAndroid();


export default {
	components: {
		'vue-pdf': vuePdf,
		QRCodigo,
		SelectorMetodoPago,
	},
	props: {
		visible: {
			type: Boolean,
			default: false,
		},
		monto: {
			type: Number,
			default: 0,
		},
		datosEmisor: {
			type: Object,
			default() { return {}; },
		},
		montoAlerta: {
			type: Number,
			default: undefined,
		},
		config: Array,
	},
	data () {
		return {
			// Formulario Emisión
			formularioEmisionValido: false,
			sucursal: undefined,
			tipoDte: undefined,
			// Formulario búsqueda Receptor
			busquedaRutDvReceptor: undefined,
			cargandoDatosReceptor: false,
			conReceptor: CON_RECEPTOR_INICIAL,
			// Formulario Receptor
			formularioReceptorValido: false,
			rutDvReceptor: undefined,
			nombreReceptor: undefined,
			direccionReceptor: undefined,
			mailReceptor: undefined,
			fonoReceptor: undefined,
			// Notificación
			notificacion: {
				visible: false,
			},
			// Boleta
			estadoDte: POR_EMITIR,
			mensajeEstadoEmisionBoleta: '',
			urlPdf: undefined,
			b64Pdf: undefined,
			puedeCompartir: false,
			// Detalle
			formularioDetalleValido: false,
			conDetalle: CON_DETALLE_INICIAL,
			nombreDetalle: NOMBRE_DETALLE_DEFECTO,
			detalleMaxLength: DETALLE_MAX_LENGTH,
			// Visor PDF
			pdfProgresoCarga: undefined,
			pdfCargado: false,
			// Formateo números
			FORMATTERS,
			// Compartir
			mail: undefined,
			formularioEnviarMailValido: false,
			telefono: undefined,
			formularioEnviarWhatsappValido: false,
			disabledConDetalle: false,
			compartirData:{
				dte:undefined, folio:undefined, monto:undefined, fecha:undefined,
				loading:false
			}
			,metodoPago: null
			,formConfig:{
				bloquearSelectorReceptor: false,
				bloquearSelectorDetalle: false,
			}
			,validacionMontoMetodoPago: v=>{
				// return true
				return this.reglaConfiguracionMetodoPago(v)
			}
			,configuracionesModal:{}
			,erroresRutReceptor:[]
			,mensajeMedioPago: undefined
		};
	},
	computed: {
		detalle: function() {
			let vm = this;
			let nombre = vm.nombreDetalle;
			let cantidad = 1;
			let precioUnitario = vm.monto;
			let item = new ApiBoletasObjects.ItemDetalle(nombre, cantidad, precioUnitario);
			let detalle = new ApiBoletasObjects.Detalle();
			detalle.añadirItem(item);
			return detalle;
		},
		sucursales: function() {
			let vm = this;
			let sucursales = [];
			let direccionCasaMatriz = vm.datosEmisor.direccion;
			let tieneCasaMatriz = (direccionCasaMatriz !== null);
			if(tieneCasaMatriz) { 
				let comunaCasaMatriz = vm.datosEmisor.nombreComuna;
				let casaMatrizTieneComuna = (comunaCasaMatriz !== null);
				let nombreCasaMatriz = casaMatrizTieneComuna ? `${direccionCasaMatriz}, ${comunaCasaMatriz}` : direccionCasaMatriz;
				let codigoCasaMatriz = undefined; // Así al hacer boleta se coloca sucursal=undefined, y se usa casa matriz.
				let casaMatriz = {'nombre': nombreCasaMatriz, 'codigo': codigoCasaMatriz};
				sucursales.push(casaMatriz);
			}
			let sucursalesContribuyente = (vm.datosEmisor.sucursales === undefined) ? [] : vm.datosEmisor.sucursales;
			sucursalesContribuyente.forEach(function(c) {
				let direccion = c.direccion;
				let nombreComuna = c.nombre_comuna;
				let sucursalTieneComuna = (nombreComuna !== null);
				let nombreSucursal = sucursalTieneComuna ? `${direccion}, ${nombreComuna}` : direccion;
				let codigo = c.codigo;
				let sucursal = {'nombre': nombreSucursal, 'codigo': codigo};
				sucursales.push(sucursal);
			});
			return sucursales;
		},
		tiposDte: function() {
			let vm = this;
			let datosEmisor = vm.datosEmisor;
			let contribuyenteTiposDte = (datosEmisor.tiposDte !== undefined) ? datosEmisor.tiposDte : [];
			let tiposDte = [];
			contribuyenteTiposDte.forEach(function(x) { 
				// Tomar el código y reemplazar item por uno de TIPOS_DTE
				// Si hay muchos elementos, mejorar eficiencia de esto usando Set
				let idx = TIPOS_DTE.findIndex(function(y){ return (x.codigo === y.codigo); });
				if(idx===-1){ return; } // Ignorar este tipo dte que puede emitir el contribuyente pero que e-Boleta no puede
				tiposDte.push(TIPOS_DTE[idx]);
			});
			return tiposDte;
		},
		puedeEmitir: function() {
			let vm = this;
			let puede = (vm.formularioEmisionValido && 
										((vm.formularioReceptorValido && vm.rutDvReceptor) || !vm.conReceptor) &&
										vm.formularioDetalleValido);
			return puede;
		},
		// Estados emisión
		porEmitir: function() {
			let vm = this;
			return (vm.estadoDte === POR_EMITIR);
		},
		emitiendo: function() {
			let vm = this;
			return (vm.estadoDte === EMITIENDO);
		},
		emitido: function() {
			let vm = this;
			return (vm.estadoDte === EMITIDO);
		},
		// Modal
		puedeCerrar: function() {
			let vm = this;
			return (vm.porEmitir || vm.emitido);
		},
		// Compartir
		urlMailTo: function() {
			let vm = this;
			let urlPdf = vm.urlPdf;
			const rut = vm.datosEmisor.rut, dv = vm.datosEmisor.dv;
			const rutDV = rut+'-'+dv
			const razonSocial = vm.datosEmisor.razonSocial
			const mensaje = NavigatorShareUtils.getMensajeCompartir(rutDV, razonSocial, urlPdf)

			const subject = NavigatorShareUtils.getSubjectCompartir(vm.compartirData.folio, vm.compartirData.monto)

			let mail = vm.mail;
			let url = `mailto:${mail}?subject=${subject}&body=${mensaje}`;
			return url;
		},
		urlWhatsapp: function() {
			let vm = this;
			let urlPdf = vm.urlPdf;
			let telefono = vm.telefono;

			const rut = vm.datosEmisor.rut, dv = vm.datosEmisor.dv;
			const rutDV = rut+'-'+dv
			const razonSocial = vm.datosEmisor.razonSocial
			const mensaje = NavigatorShareUtils.getMensajeCompartir(rutDV, razonSocial, urlPdf)

			let url = `https://api.whatsapp.com/send?phone=${telefono}&text=${mensaje}`;
			return url;
		},
		vendedor: function() {
			let vm = this;
			let vendedor = vm.$store.getters['usuario/usuario']; // Asignarle el nombre de usuario actual
			return vendedor;
		},
	},
	methods: {
		// Iniciar emisión: emitir inmediatamente //marzo-2022 se mueve la alerta de montos a la calculadora
		iniciarEmision: function() {
			let vm = this;
			vm.emitir();
		},
		// Modal
		cerrar: function() {
			let vm = this;
			vm.$emit('cerrado');
			// vm.visible = false;
			vm.resetCompartirData();
		},
		// Receptor
		calcularDv: function(rut) {
			// Determinar dv por fuerza bruta
			let dvs = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'K'];
			let dv;
			dvs.forEach(function(x){ if(ApiBoletasObjects.RUT.dvValido(rut, x)){ dv = x; } });
			if(dv===undefined){ throw `No se pudo computar dv para rut ${rut}`; }
			return dv;
		},
		datosReceptor: function() {
			let vm = this;
			let rutDv = vm.rutDvReceptor;
			let partesRutDv = rutDv.match(/^(\w+)-(\w)$/);
			let rut = partesRutDv[1];
			let dv = partesRutDv[2];
			let datosReceptor = {
				rut: rut,
				dv: dv,
				razonSocial: vm.nombreReceptor, 
				direccion: vm.direccionReceptor,
			};
			return datosReceptor;
		},
		cargarDatosReceptor: function() {
			let vm = this;
			let rutDv = vm.busquedaRutDvReceptor;

			function dgv(T) {
				var M = 0;
				var S = 1;
				while (T) {
					T = Math.floor(T / 10);
					var digit = T % 10;
					S = (S + digit * (9 - M % 6)) % 11;
					M++;
				}
				return S ? S - 1 : 'k';
			}

			if( !dgv(rutDv) ){
				this.erroresRutReceptor = 'El rut ingresado no es válido'
				return false
			}
			
			// Inhibir ejecución si el RUT con DV no es correcto o está vacío
			if(vm.validarBusquedaRutDvReceptor(rutDv) !== true || rutDv === undefined || rutDv === null || rutDv === '') { return; }
			
			// Entrada tiene patrón esperado, extraer rut y dv; reemplazarlo por formato rut-dv
			let rutDvLimpio = vm.limpiarRutDv(rutDv);
			let matches = rutDvLimpio.match(SOFT_RUT_DV_REGEX); // [rutdv, rut, dv]
			let rut = matches[1];
			let dv = matches[2];
			vm.busquedaRutDvReceptor = `${rut}-${dv}`; // Reformatear rut
			vm.$refs.formularioReceptor.reset();
			
			vm.cargandoDatosReceptor = true;
			
			let exito = function(data) {
				vm.rutDvReceptor = vm.busquedaRutDvReceptor;
				vm.nombreReceptor = data.razonSocial;
				let direccion = data.direccion;
				let comuna = data.nombreComuna;
				if(direccion && comuna) {
					// Si viene dirección y comuna...
					vm.direccionReceptor = `${data.direccion}, ${data.nombreComuna}`;
				}
				else if(direccion) {
					// Si viene solo dirección...
					vm.direccionReceptor = direccion;
				}
				vm.cargandoDatosReceptor = false;
			};
			let error = function(err) {
				vm.rutDvReceptor = vm.busquedaRutDvReceptor;
				vm.cargandoDatosReceptor = false;
				if(err.response === undefined) {
					vm.notificarAlerta(`Hubo un error al obtener datos de receptor. Contacte a soporte.`);
				}
				else {
					let status = err.response.status;
					if(status === 404) {
						vm.notificarAlerta(`No hay información registrada para este receptor. Por favor indique su nombre y opcionalmente su dirección.`);
					}
					else if(status === 418) {
						vm.notificarAlerta(`Hay información ambigua registrada para este receptor. Contacte a soporte.`);
					}
					else {
						vm.notificarAlerta(`Hubo un error al obtener datos de receptor. Contacte a soporte.`);
					}
				}
			};
			
			let receptorDataExitoExecutor = receptorDataExitoExecutionManager.getExecutor(exito);
			let receptorDataErrorExecutor = receptorDataErrorExecutionManager.getExecutor(error);
			
			InfoContribuyente.infoReceptor(rut,
				function(res) { 
					receptorDataErrorExecutionManager.inhibitExecution(); 
					receptorDataExitoExecutor.attemptExecution(res.data); 
				}, 
				function(err) { 
					receptorDataExitoExecutionManager.inhibitExecution(); 
					receptorDataErrorExecutor.attemptExecution(err);
			});
		},
		establecerReceptorGenerico: function() {
			let vm = this;
			vm.rutDvReceptor = `${Boletas.RECEPTOR_GENERICO.RUT}-${Boletas.RECEPTOR_GENERICO.DV}`;
			vm.direccionReceptor = Boletas.RECEPTOR_GENERICO.DIRECCION;
			vm.nombreReceptor = Boletas.RECEPTOR_GENERICO.RAZON_SOCIAL;
		},
		// Emitir
		emitir: async function() {
			let vm = this;
			let tipoDte = vm.tipoDte.codigo;
			let rutEmisor = new ApiBoletasObjects.RUT(vm.datosEmisor.rut, vm.datosEmisor.dv);
			let emisor = new ApiBoletasObjects.Emisor(rutEmisor);
			emisor.sucursal = vm.sucursal.codigo;

			const metodoPago = vm.metodoPago;
			
			let datosReceptor = vm.datosReceptor();
			let rutReceptor = new ApiBoletasObjects.RUT(datosReceptor.rut, datosReceptor.dv);
			let razonSocialReceptor = datosReceptor.razonSocial;
			let receptor = new ApiBoletasObjects.Receptor(rutReceptor, razonSocialReceptor);
			receptor.direccion = datosReceptor.direccion || undefined;
			receptor.contacto = vm.fonoReceptor || undefined;
			receptor.email = vm.mailReceptor || undefined;

			if( vm.reglaConfiguracionMetodoPago(metodoPago) !== true){
				const mensaje = vm.reglaConfiguracionMetodoPago(metodoPago);
				return vm.notificarError(`Error al generar boleta: ${mensaje}`); 
			}

			let detalle = vm.detalle;
			let boleta = new Boletas.Boleta(tipoDte, emisor, receptor, detalle);
			boleta.vendedor = vm.vendedor;
			boleta.meta = { 'info_emisor': vm.datosEmisor }; // Solicitado por rroman 16-feb-2021
			if( !!metodoPago )
				boleta.medioPago = metodoPago.id_sii;
			
			// Preparar emisión boleta, preparar estados
			vm.mensajeEstadoEmisionBoleta = 'Generando boleta...';
			vm.estadoDte = EMITIENDO;
			vm.urlPdf = undefined;
			vm.b64Pdf = undefined;
			vm.pdfCargado = false;
			
			// Resetear campos compartir
			vm.$refs.formularioEnviarMail.reset();
			vm.$refs.formularioEnviarWhatsapp.reset();
			
			// Si hay mail de receptor ingresado, copiarlo a la casilla de mail para enviar
			let mailReceptor = vm.mailReceptor;
			if(mailReceptor !== undefined) {
				vm.mail = mailReceptor;
			}
			const fonoReceptor = vm.fonoReceptor;
			if(fonoReceptor != undefined) {
				vm.telefono = fonoReceptor.includes('+')?fonoReceptor:'+569'+fonoReceptor;
				if( !vm.validarTelefono(vm.telefono) ){
					vm.telefono = '+569'+vm.telefono;
				}
			}
			
			vm.compartirData.dte = undefined;
			vm.compartirData.folio = undefined;
			vm.compartirData.monto = undefined;
			
			// Callbacks
			let cleanUp = function() {
				vm.estadoDte = POR_EMITIR;
				vm.mensajeEstadoEmisionBoleta = '';
			};
			let dteFinalExito = function(data) {
				vm.mensajeEstadoEmisionBoleta = 'Boleta generada!';

				vm.compartirData.monto = vm.monto;
				let urlPublica = data.pdf_public_url;
				let codificacionB64 = data.b64encoded_pdf;
				
				vm.compartirData.dte = data.dte;
				vm.compartirData.folio = data.folio;
				vm.compartirData.fecha = new Date().parseUTCToLocal();
				
				try{apiPingSistema(vm.datosEmisor.rut, data.dte, data.folio);}catch(e){}
				
				vm.urlPdf = urlPublica;
				vm.b64Pdf = codificacionB64;
				vm.estadoDte = EMITIDO;
				vm.$emit('emitido');
				vm.resetearCondicionesModal()
			};
			let dteFinalError = function(error) {
				vm.notificarError(`Error al generar boleta: ${error}`);
				cleanUp();
			};
			
			try{
				boleta.meta.geolocalizacion = await vm.$geolocation.getLocation();
			}catch(e){
				dteFinalError(e);
				return;
			}

			boleta.meta.plataforma = config.PLATAFORMA;
			
			// Entregar callbacks a boleta
			boleta.dteFinalSuccessCallback = dteFinalExito;
			boleta.dteFinalFailCallback = dteFinalError;
			
			// Finalmente iniciar generación
			boleta.emitir();
		},
		// PDF
		visorPdfError: function(err) {
			let vm = this;
			vm.notificarError('No se pudo mostrar boleta. Intente descargarla.');
		},
		visorpdfCargado: function() {
			let vm = this;
			vm.pdfCargado = true;
		},
		visorPdfProgreso: function(progreso) {
			let vm = this;
			vm.pdfProgresoCarga = progreso*100;
		},
		// Notificaciones
		notificarAlerta: function(mensaje) {
			let vm = this;
			vm.notificar(mensaje, 'warning');
		},
		notificarError: function(mensaje) {
			let vm = this;
			vm.notificar(mensaje, 'error');
		},
		notificarExito: function(mensaje) {
			let vm = this;
			vm.notificar(mensaje, 'success');
		},
		notificar: function(mensaje, color) {
			let vm = this;
			vm.notificacion.mensaje = mensaje;
			vm.notificacion.color = color;
			vm.notificacion.visible = true;
		},
		// Validaciones emisión
		validarSucursal: function(v) {
			return (v !== undefined) || 'Sucursal debe definirse';
		},
		validarTipoDte: function(v) {
			return (v !== undefined) || 'Tipo de boleta debe definirse';
		},
		validarMail: function(v) {
			if(v === undefined || v === null || v === '') {
				return 'Debe ingresar una dirección de e-mail';
			}
			let matches = v.match(/.+@.+\..+/);
			if(matches === null) {
				return 'Ingrese una dirección de e-mail apropiada';
			}
			return true;
		},
		validarMailReceptor: function(v) {
			
			if( this.configuracionesModal.REQUIERE_RECEPTOR !== true ) {
				if(v === undefined || v === null || v === '') {
					return true;
				}
			}else if( v === undefined || v === null || v === '' ){
				return false
			}
			// Si no es vacío, entonces validar si calza patrón de email
			let matches = v.match(/.+@.+\..+/);
			if(matches === null) {
				return 'Ingrese una dirección de e-mail apropiada';
			}
			return true;
		},
		validarTelefonoReceptor: function(v) {

			if( this.configuracionesModal.REQUIERE_RECEPTOR !== true ) {
				if(v === undefined || v === null || v === '') {
					return true;
				}
			}else if( v === undefined || v === null || v === '' ){
				return false
			}
			
			return this.validarTelefono(v);
		},
		validarTelefono: function(v) {
			if(v === undefined || v === null || v === '')	return 'Debe ingresar un teléfono';

			let matches = v.match(/^[\+|\d][\d|\s|+$]+$/);
			if(matches === null) {
				return 'Ingrese un teléfono apropiado';
			}
			return true;
		},
		// Validaciones búsqueda receptor
		limpiarRutDv : function(rutDv) {
			// Remover puntos y espacios
			return rutDv.replace(/\.|\s/g, '');
		},
		validarBusquedaRutDvReceptor: function(v) {
			let vm = this;
			if(v === undefined || v === null || v === '') {
				return true; // Permitir que búsqueda esté vacía
			}
			let rutDvLimpio = vm.limpiarRutDv(v);
			let matches = rutDvLimpio.match(SOFT_RUT_DV_REGEX);
			if(matches === null) { // No hubo coincidencia con patrón
				return 'Formato: sin puntos con guión. Ejemplo: 12345678-9';
			}
			let rut = matches[1]; // el rut [rutdv, rut, dv]
			let dv = matches[2];
			let dvCalculado = vm.calcularDv(rut);
			
			// Comparar dígitos, pasar ambos a mayúsculas para evitar problemas con k y K
			return (`${dv}`.toUpperCase() === `${dvCalculado}`.toUpperCase()) || 'RUT no es válido';
		},
		// Validaciones receptor
		validarRutDvReceptor: function(v) {
			return (v !== undefined) || 'RUT con DV receptor debe definirse';
		},
		validarNombreReceptor: function(v) {
			return ((v !== undefined) && (v !== '')) || 'Nombre receptor debe definirse';
		},
		validarNombreDetalle: function(v) {
			if((v === undefined) || (v === '') || (v === null)) {
				return 'Detalle debe definirse';
			}
			else {
				let length = v.length;
				if(length > DETALLE_MAX_LENGTH) {
					return 'Detalle demasiado largo';
				}
				else {
					return true;
				}
			}
		},
		// Compartir
		compartir: function() {
			let vm = this;
			let url = vm.urlPdf;
			let text = '';
			let title = 'Boleta';
			
			const rut = vm.datosEmisor.rut, dv = vm.datosEmisor.dv;
			const razonSocial = vm.datosEmisor.razonSocial
			const rutDV = rut+'-'+dv
			
			const fileName = `Boleta_${rutDV}-${vm.compartirData.folio}.pdf`
			
			const fileConfig = {
				url, fileName, rut:rutDV, razonSocial
			}
			
			NavigatorShareUtils.compartir(url, text, title, fileConfig);
		},
		async enviarBoletaEmail(){
			try{

				this.compartirData.loading = true
				const to = this.mail;
				const rut = this.datosEmisor.rut+'-'+this.datosEmisor.dv;
				let resp = await compartirBoletaEmail(to, rut, this.datosEmisor.razonSocial, this.compartirData.monto, this.compartirData.folio, this.compartirData.dte, this.urlPdf, this.compartirData.fecha)
				this.compartirData.loading = false;
				this.notificarExito(resp.data)
			}catch(e){
				this.compartirData.loading = false;
				this.notificarError('Ha ocurrido un error al enviar la boleta por email')
			}
		},
		imprimir: function() {
			let vm = this;
			let b64Pdf = vm.b64Pdf;
			// printJs espera un b64 "mimeless".
			let mimelessB64Pdf = base64Utils.removeB64MimeInfo(b64Pdf);
			let printJsParams = {
				'printable': mimelessB64Pdf,
				'type': 'pdf',
				'base64': true,
			};
			
			if(ANDROID) {
				let Android = windowUtils.getAndroidObject();
				// print es un wrapper para printJS en la app de Android
				Android.print(printJsParams);
			}
			else {
				printJS(printJsParams);
			}
		}
		,resetCompartirData(){
			this.compartirData.dte = undefined;
			this.compartirData.folio = undefined;
			this.compartirData.monto = undefined;
			this.compartirData.loading = false;
		}
		,obtenerConfiguracionModal(arrayConfiguraciones){

			const configs = {};

			for( let {condiciones, configuraciones} of arrayConfiguraciones ){

				let flag = true;

				for( let key in condiciones ){

					switch(key){
						case 'MONTO_MAYOR_QUE': 
							flag = this.monto > condiciones.MONTO_MAYOR_QUE && flag;
						break;
						case 'MONTO_MENOR_QUE':
							flag = this.monto < condiciones.MONTO_MENOR_QUE && flag;
						break;
						case 'MEDIO_PAGO':
							flag = this.metodoPago !== null 
								&& this.metodoPago.codigo === condiciones.MEDIO_PAGO
								&& flag;
						break;
						default:
							flag = false;
					}
					
				}
				if( flag )
					Object.assign(configs, configuraciones)
			}

			return configs;
		}
		,aplicaDiccionarioConfiguraciones(diccionarioConfig){

			const vm = this;
			const handlers = {
				REQUIERE_RECEPTOR(activo=true){
					vm.conReceptor = activo;
					vm.formConfig.bloquearSelectorReceptor = activo;
				},
				REQUIERE_DETALLE(activo=true){
					vm.conDetalle = activo;
					vm.formConfig.bloquearSelectorDetalle = activo;
				},
				REQUIERE_MEDIO_PAGO(activo=true){
					vm.formConfig.requiereMedioPago = activo;
				}
			}

			vm.configuracionesModal = diccionarioConfig;

			for( let key in handlers ){
				const handler = handlers[key]
				const estado = Object.hasOwn(diccionarioConfig, key) &&
					diccionarioConfig[key];
				handler(estado)
			}
		}
		,aplicarConfig(){

			const configs = this.config;

			const configAAplicar = this.obtenerConfiguracionModal(configs);

			const metodoPago = this.metodoPago
			let validaciones = [];

			if( metodoPago != null ){
				validaciones = configs.filter(c=>c.condiciones.MEDIO_PAGO === metodoPago.codigo)
			}else{
				validaciones = configs.filter(c=>!Object.hasOwn(c.condiciones, 'MEDIO_PAGO'))
			}
			// const configuraciones = this.obtenerConfiguracionModal(validaciones)

			this.mensajeMedioPago = undefined;

			const msjs = [];
			let strCondiciones = []
			let strConfig = {}
			for( let {condiciones, configuraciones} of validaciones ){

				let flag = true;
				let cond = [];
				for( let key in condiciones ){

					switch(key){
						case 'MONTO_MAYOR_QUE': 
							flag = this.monto > condiciones.MONTO_MAYOR_QUE && flag;
							cond.push('el monto sea mayor que $'+condiciones.MONTO_MAYOR_QUE)
						break;
						case 'MONTO_MENOR_QUE':
							flag = this.monto < condiciones.MONTO_MENOR_QUE && flag;
							cond.push('el monto sea menor que $'+condiciones.MONTO_MENOR_QUE)
						break;
						case 'MEDIO_PAGO':
							flag = this.metodoPago !== null 
								&& this.metodoPago.codigo === condiciones.MEDIO_PAGO
								&& flag;
								cond.unshift('el medio de pago sea '+ condiciones.MEDIO_PAGO.replaceAll('_', ' ').toLocaleLowerCase())
						break;
						default:
							flag = false;
					}
				}
				if( flag ){
					strCondiciones.push(...cond)
					strConfig = {...strConfig, ...configuraciones}
				}
			}

			for( let config in strConfig ){
				switch(config){
					case 'REQUIERE_RECEPTOR':
						msjs.push('receptor')
					break;
					case 'REQUIERE_DETALLE':
						msjs.push('detalle')
					break;
					case 'REQUIERE_MEDIO_PAGO':
						msjs.push('medio de pago')
					break;
				}
			}

			function listarArray(arr){
				return arr.length<=1?arr.join(', '):
					arr.slice(0,-1).join(', ')+' y '+arr.slice(-1);
			}

			if( msjs.length > 0 ){
				let strC = listarArray(strCondiciones)

				let strCampos = listarArray(msjs)
				this.mensajeMedioPago = msjs.includes('medio de pago')?
					`Debe indicar el medio de pago.`
					:`Debe indicar datos del ${strCampos}`;
			}else
				this.mensajeMedioPago = undefined;

			this.$nextTick(()=>{
				if( !!this.$refs.formularioEmision )
					this.$refs.formularioEmision.resetValidation();
			})
			this.aplicaDiccionarioConfiguraciones(configAAplicar)
		}
		,resetearCondicionesModal(){
			const vm = this;
			vm.conDetalle = false;
			vm.formConfig.bloquearSelectorDetalle = false;
			vm.conReceptor = false;
			vm.formConfig.bloquearSelectorReceptor = false;
			vm.configuracionesModal = {}
			vm.erroresRutReceptor = [];
			vm.mensajeMedioPago = undefined;
			vm.aplicarConfig();
		}
		,reglaConfiguracionMetodoPago(metodoPago){
			const vm = this;

			if( metodoPago != null  ){
				const {codigo, nombre} = metodoPago;

				const validaciones = this.config.filter(c=>c.condiciones.MEDIO_PAGO === codigo)
				
				const configuraciones = this.obtenerConfiguracionModal(validaciones)

				for( let config in configuraciones ){
					switch(config){
						case 'REQUIERE_RECEPTOR':
							if(!this.formularioReceptorValido){
								if(vm.$refs.formularioReceptor === undefined)	return;
								vm.$refs.formularioReceptor.validate()
								vm.$nextTick(function() {
									if(!this.formularioReceptorValido)	return `Debe indicar datos del receptor y detalle.`
								});
							}
						break;
						case 'REQUIERE_DETALLE':
							if(!this.formularioDetalleValido)
								return `Debe indicar datos del receptor y detalle.`
						break;
					}
				}
				return true;
			}
			return !this.formConfig.requiereMedioPago||'El medio de pago es requerido';
		}
		,validarCampos(){
			
			let vm = this;
			vm.$nextTick(function() {
				vm.$refs.formularioEmision.validate()
			});
		}
	},
	watch: {
		conReceptor: function(newVal) {
			let vm = this;
			let conReceptor = newVal;
			
			if(!conReceptor) {
				vm.$refs.formularioReceptor.reset();
				vm.resetearCondicionesModal()
				vm.establecerReceptorGenerico();
				// Por si se estaba buscando receptor...
				vm.cargandoDatosReceptor = false;
				receptorDataExitoExecutionManager.inhibitExecution();
				receptorDataErrorExecutionManager.inhibitExecution();
			}
			else {
				vm.$nextTick(function() {
					vm.$refs.formularioReceptor.reset();
					vm.$refs.formularioBusquedaReceptor.reset();
				});
			}
		},
		conDetalle: function(newVal) {
			let vm = this;
			let conDetalle = newVal;
			if(!conDetalle) {
				vm.nombreDetalle = NOMBRE_DETALLE_DEFECTO;
			}
			else {
				vm.$nextTick(function() {
					vm.$refs.formularioDetalle.reset();
				});
			}
		},
		visible: function(newVal) {
			let vm = this;
			let visible = newVal;

			if(visible) {
				vm.resetearCondicionesModal()
				vm.$nextTick(function() {

					vm.$refs.metodoPagoSelector.reset()
					// Reestablecer formularios
					vm.$refs.formularioBusquedaReceptor.reset();
					//vm.$refs.formularioEmision.reset(); // No resetear, coberg (21-jul-2020)
					// Establecer algunos valores iniciales
					vm.conReceptor = CON_RECEPTOR_INICIAL;
					vm.conDetalle = vm.monto==0 ? true : CON_DETALLE_INICIAL;
					vm.disabledConDetalle = vm.monto==0 ? true : false;
					if(!CON_RECEPTOR_INICIAL) {
						vm.establecerReceptorGenerico();
					}
					vm.estadoDte = POR_EMITIR;
					vm.mensajeAvanceEmision = MENSAJE_ESTADO_EMISION_INICIAL;
					if(vm.sucursales.length > 0) {
						vm.sucursal = vm.sucursales[0];
					}
					if(vm.tiposDte.length > 0) {
						vm.tipoDte = vm.tiposDte[0];
					}
					if(!CON_DETALLE_INICIAL && vm.monto!=0) {
						vm.nombreDetalle = NOMBRE_DETALLE_DEFECTO;
					}
					else {
						vm.$refs.formularioDetalle.reset();
					}

					vm.aplicarConfig()
					
				});
				vm.notificacion.visible = false;
			}
		},
		tiposDte: function(newVal) {
			let vm = this;
			if(newVal.length === 1) {
				vm.tipoDte = newVal[0];
			}
			else {
				vm.tipoDte = undefined;
			}
		},
	},
	mounted: function() {
		let vm = this;
		let setPuedeCompartir = function() {
			vm.puedeCompartir = NavigatorShareUtils.puedeCompartir();
		};
		vm.$nextTick(setPuedeCompartir);
	},
	created: function() {
	},
};
</script>